import { z } from 'zod';

export const registrationStepFourSchema = z.object({
    gender: z.enum(['male', 'female'], { message: 'Пол обязателен' }),
    looks_for: z.enum(['male', 'female', 'any'], { message: 'Пол обязателен' }),
    min_age: z.number(),
    max_age: z.number(),
});

export type RegistrationStepFourType = z.infer<typeof registrationStepFourSchema>;
